import { render, staticRenderFns } from "./BoInfo.vue?vue&type=template&id=57385fa4&"
import script from "./BoInfo.vue?vue&type=script&lang=js&"
export * from "./BoInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports